import { ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import {
    ContentBlock,
    OneButtonProps,
    ButtonAndSecondaryLinkProps
} from "@/components/wpl/content-block/src";
import { AspectRatios, Image } from "@/components/wpl/image/src";
import {
    RowRevised,
    BGProps,
    StyledBackground
} from "@/libraries/wpl/foundations/src";

export type ImagePositions = "left" | "right";

export interface PatternHeroProps {
    headerText: ReactNode;
    bodyText: ReactNode;
    imageLink: string;
    imageAltText: string;
    imagePosition?: ImagePositions;
    imageCss?: string;
    className?: string;
    ctaProps?: OneButtonProps | ButtonAndSecondaryLinkProps;
    backgroundProperties?: BGProps;
    aspectRatio?: AspectRatios;
}

const heroStyle = css({
    [media.above.sm]: { padding: "80px 0" },
    [media.only.sm]: {
        padding: "60px 0"
    },
    [media.below.sm]: {
        padding: "40px 0"
    }
});

export const HeroImageTextSide = ({
    headerText,
    bodyText,
    imageLink,
    imageAltText,
    imagePosition,
    imageCss,
    className = "",
    ctaProps,
    backgroundProperties,
    aspectRatio
}: PatternHeroProps) => {
    return (
        <StyledBackground {...backgroundProperties}>
            <div className={className} css={heroStyle}>
                <RowRevised layout="6-6" alignItems="center">
                    <ContentBlock
                        headerText={headerText}
                        headerType="h1"
                        bodyText={bodyText}
                        ctaProps={ctaProps}
                    />

                    <Image
                        src={imageLink}
                        alt={imageAltText}
                        aspectRatio={aspectRatio || "none"}
                        css={[
                            imagePosition === "left" &&
                                css({ order: "-1", imageCss }),
                            imagePosition !== "left" && css({ imageCss })
                        ]}
                    />
                </RowRevised>
            </div>
        </StyledBackground>
    );
};
